﻿export default class DataBinder {
  constructor(context) {
    this.defaultContext = context;
  }
  populate(pageId, context, page) {
    if (!page) page = document.getElementById(pageId);
    if (!page) page = document;
    if (context === null) context = this.defaultContext;
    if (context === undefined) context = this.defaultContext;

    let elementsSrc = page.querySelectorAll('[data-src]:not(template)');
    for (let i = 0; i < elementsSrc.length; i++) {
      let element = elementsSrc[i];
      let model = context;
      if (element.dataset.model) {
        if (model[element.dataset.model]) {
          model = model[element.dataset.model];
        }
      }

      let key = element.dataset.src;
      let value = model[key];
      if (typeof value !== 'undefined') {
        element.src = value;
      } else {
        //try to phase template
        let regex = /\{([^}]+)\}/g; //key.match(/\{([^}]+)\}/g);
        let template = key;
        let keys = []
        var match;
        //check if the values exist
        let valuesExisits = false;
        while (match = regex.exec(template)) {
          keys.push(match);
          let keyValue = model[match[1]];
          if (typeof keyValue !== "undefined")
            valuesExisits = true;
        }
        if (keys.length === 0) valuesExisits = false;
        //resolve template
        if (valuesExisits) {
          let templateResolved = key.replace(/\{([^}]+)\}/g, function (match, p1, offset, string) {
            return model[p1] || null;;
          });
          element.src = templateResolved;
        }
      }
    }
    let elementsStyle = page.querySelectorAll('[data-style]:not(template)');
    for (let i = 0; i < elementsStyle.length; i++) {
      let element = elementsStyle[i];
      let model = context;
      if (element.dataset.model) {
        if (model[element.dataset.model]) {
          model = model[element.dataset.model];
        }
      }

      let key = element.dataset.style;
      let value = model[key];
      if (typeof value !== 'undefined') {
        element.style = value;
      } else {
        //try to phase template
        let regex = /\{([^}]+)\}/g; //key.match(/\{([^}]+)\}/g);
        let template = key;
        let keys = []
        var match;
        //check if the values exist
        let valuesExisits = false;
        while (match = regex.exec(template)) {
          keys.push(match);
          let keyValue = model[match[1]];
          if (typeof keyValue !== "undefined")
            valuesExisits = true;
        }
        if (keys.length === 0) valuesExisits = false;
        //resolve template
        if (valuesExisits) {
          let templateResolved = key.replace(/\{([^}]+)\}/g, function (match, p1, offset, string) {
            return model[p1] || null;
          });
          element.style = templateResolved;
        }
      }
    }
    let elementsOnClick = page.querySelectorAll('[data-onclick]:not(template)');
    for (let i = 0; i < elementsOnClick.length; i++) {
      let element = elementsOnClick[i];
      let model = context;
      if (element.dataset.model) {
        if (model[element.dataset.model]) {
          model = model[element.dataset.model];
        }
      }

      let key = element.dataset.onclick;
      let value = model[key];
      if (typeof value !== 'undefined') {
        if (typeof value === 'function') {
          element.onclick = value;
        } else {
          element.setAttribute('onclick', value);
        }
      } else {
        //try to phase template
        let regex = /\{([^}]+)\}/g; //key.match(/\{([^}]+)\}/g);
        let template = key;
        let keys = []
        var match;
        //check if the values exist
        let valuesExisits = false;
        while (match = regex.exec(template)) {
          keys.push(match);
          let keyValue = model[match[1]];
          if (typeof keyValue !== "undefined")
            valuesExisits = true;
        }
        if (keys.length === 0) valuesExisits = false;
        //resolve template
        if (valuesExisits) {
          let templateResolved = key.replace(/\{([^}]+)\}/g, function (match, p1, offset, string) {
            return model[p1] || null;
          });
          element.setAttribute('onclick', templateResolved);
        }
      }
    }
    let elementsValue = page.querySelectorAll('[data-value]:not(template)');
    for (let i = 0; i < elementsValue.length; i++) {
      let element = elementsValue[i];
      let model = context;
      if (element.dataset.model) {
        if (model[element.dataset.model]) {
          model = model[element.dataset.model];
        }
      }
      let key = element.dataset.value;
      let value = model[key];
      if (typeof value !== 'undefined') {
        element.value = value;
      } else {
        element.value = null;
      }
    }
    let elementsInnerText = page.querySelectorAll('[data-inner-text]:not(template)');
    for (let i = 0; i < elementsInnerText.length; i++) {
      let element = elementsInnerText[i];
      let model = context;
      if (element.dataset.model) {
        if (model[element.dataset.model]) {
          model = model[element.dataset.model];
        }
      }
      let key = element.dataset.innerText;
      let value = model[key];
      if (key == "this") value = model;
      if (typeof value !== 'undefined') {
        element.innerText = value;
      }
    }
    let elementsInnerHTML = page.querySelectorAll('[data-inner-html]:not(template)');
    for (let i = 0; i < elementsInnerHTML.length; i++) {
      let element = elementsInnerHTML[i];
      let model = context;
      if (element.dataset.model) {
        if (model[element.dataset.model]) {
          model = model[element.dataset.model];
        }
      }
      let key = element.dataset.innerHtml;
      let value = model[key];
      if (typeof value !== 'undefined') {
        element.innerHTML = value;
      }
    }
    let elementsShow = page.querySelectorAll('[data-show]:not(template)');
    for (let i = 0; i < elementsShow.length; i++) {
      let element = elementsShow[i];
      let model = context;
      if (element.dataset.model) {
        if (model[element.dataset.model]) {
          model = model[element.dataset.model];
        }
      }
      let key = element.dataset.show;
      let value = model[key];
      if (value)
        element.style.display = '';
      else
        element.style.display = 'none';
    }
    let elementsHidden = page.querySelectorAll('[data-hidden]:not(template)');
    for (let i = 0; i < elementsHidden.length; i++) {
      let element = elementsHidden[i];
      let model = context;
      if (element.dataset.model) {
        if (model[element.dataset.model]) {
          model = model[element.dataset.model];
        }
      }
      let key = element.dataset.hidden;
      let value = model[key];
      if (value)
        element.style.display = 'none';
      else if (element.style.display === 'none')
        element.style.display = '';

    }
    let elementsChecked = page.querySelectorAll('[data-checked]:not(template)');
    for (let i = 0; i < elementsChecked.length; i++) {
      let element = elementsChecked[i];
      let model = context;
      if (element.dataset.model) {
        if (model[element.dataset.model]) {
          model = model[element.dataset.model];
        }
      }
      let key = element.dataset.checked;
      let value = model[key];
      if (typeof value === "boolean" && value === true) {
        element.checked = true;
      }
      else if (value === element.value) {
        element.checked = true;
      } else {
        element.checked = false;
      }
    }
    let elementsTemplate = page.querySelectorAll('[data-template]');
    for (let i = 0; i < elementsTemplate.length; i++) {
      let element = elementsTemplate[i];
      let model = context;
      if (element.dataset.model) {
        if (model[element.dataset.model]) {
          model = model[element.dataset.model];
        }
      }
      let templateId = element.dataset.template;
      let template = document.querySelector("#" + templateId);
      if (template) {
        //clear children
        while (element.firstChild) {
          element.removeChild(element.firstChild);
        }
        for (let j = 0; j < model.length; j++) {
          let itemModel = model[j];
          //copy template
          let clone = document.importNode(template.content, true);
          //and populate it
          this.populate(null, itemModel, clone);
          //add it
          element.appendChild(clone);
        }
      }
    }

  }
  createAndShow(templateId, model, destinationId) {
    //copy template and populate
    let element = this.create(templateId, model);
    //add to destination
    this.show(element, destinationId);
  }
  show(element, destinationId) {
    if (!element) return;
    //find destination
    let destination = document.body;
    if (destinationId)
      destination = document.getElementById(destinationId);
    //add to destination
    if (!destination) return;
    destination.appendChild(element);
    return element;
  }
  create(templateId, model) {
    //copy template and populate
    var template = document.getElementById(templateId);
    if (!template) return;
    let element = document.importNode(template.content, true);
    if (!element) return;
    this.populate("", model, element);
    return element;
  }

}

